export default class Patient {
  constructor (data) {
    this.createdAt = data.created_at
    this.dateOfBirth = data.date_of_birth
    this.email = data.email
    this.firstName = data.first_name
    this.lastName = data.last_name
    this.mobilePhone = data.mobile_phone
    this.origin = data.origin
    this.practiceUuid = data.practice_uuid
    this.updatedAt = data.updated_at
    this.uuid = data.uuid
  }
}
